import Vue from 'vue'
import Vuex from 'vuex'

import license from '@/stores/settings/license'
import switchTariff from '@/stores/settings/switchTariff'
import additional from '@/stores/settings/additional'
import promisedPayment from '@/stores/settings/promisedPayment'
import transferFunds from '@/stores/settings/transferFunds'
import registrySettings from '@/stores/settings/registrySettings'
import ISGattributes from '@/stores/settings/ISGattributes'
import TunnelRadAttributes from '@/stores/settings/tunnelRadiusAttributes'
import companies from '@/stores/settings/companies'
import ipPools from '@/stores/settings/ipPools'
import firewalls from '@/stores/settings/firewalls'
import firewallRules from '@/stores/settings/firewallRules'
import NASlist from '@/stores/settings/NASlist'
import radiusAccounts from '@/stores/settings/radiusAccounts'
import ISGprofile from '@/stores/settings/ISGprofile'
import documentTemplates from '@/stores/settings/documentTemplates'
import profilesOfDocuments from '@/stores/settings/profilesOfDocuments'
import replacementsInDocument from '@/stores/settings/replacementsInDocument'
import emergencyCalls from '@/stores/settings/emergencyCalls'
import telephoneOperators from '@/stores/settings/telephoneOperators'
import telSupplierServiceReports from '@/stores/settings/telSupplierServiceReports'
import archiveDB from '@/stores/settings/archiveDB'
import netFlowProviders from '@/stores/settings/netFlowProviders'
import trafficCollectors from '@/stores/settings/trafficCollectors'
import paymentSystems from '@/stores/settings/paymentSystems'
import voluntarySuspension from '@/stores/settings/voluntarySuspension'
import userIndependentServicesConnect from '@/stores/settings/userIndependentServicesConnect'
import dynamicShaping from '@/stores/settings/dynamicShaping'
import rabbitMQ from '@/stores/settings/rabbitMQ'
import DHCPv6 from '@/stores/settings/DHCPv6'
import collectors from '@/stores/settings/collectors'
import captivePortal from '@/stores/settings/captivePortal'
import rentsoft from '@/stores/settings/rentsoft'
import httpServers from '@/stores/settings/httpServers'
import chat from '@/stores/settings/ts_chat'
import editProfile from '@/stores/settings/editProfile'
import availReports from '@/stores/settings/reports_settings'
import availDocs from '@/stores/settings/customer_docs_settings'
import routes from '@/stores/settings/routes'
import permissions from '@/stores/settings/permissions'
import activatingCard from '@/stores/settings/activating_card'
import tv24 from '@/stores/settings/24tv'

import tariff from '@/stores/tariffing/tariff'
import service from '@/stores/tariffing/service'
import telZones from '@/stores/tariffing/telZones'
import telDirections from '@/stores/tariffing/telDirections'
import timeRange from '@/stores/tariffing/timeRange'
import trafficClasses from '@/stores/tariffing/trafficClasses'
import radiusAttr from '@/stores/tariffing/radiusAttr'
import accountingPeriod from '@/stores/tariffing/accountingPeriod'
import contractType from '@/stores/tariffing/contractType'
import oneTimeService from '@/stores/tariffing/oneTimeService'
import periodicServices from '@/stores/tariffing/periodicServices'
import ipTrafficServices from '@/stores/tariffing/ipTrafficServices'
import IPTVservices from '@/stores/tariffing/IPTVservices'
import hotspotServices from '@/stores/tariffing/hotspotServices'
import dialupServices from '@/stores/tariffing/dialupServices'
import telephonyServices from '@/stores/tariffing/telephonyServices'
import vodServices from '@/stores/tariffing/vodServices'
import freezedServices from '@/stores/tariffing/freezedServices'
import coefficientScheme from '@/stores/tariffing/coefficientScheme'
import chargePolicies from '@/stores/tariffing/chargePolicies'
import payment from '@/stores/tariffing/payment'

import groups from '@/stores/users/groups'
import irdeto from '@/stores/users/irdeto'
import systemUsersShortData from '@/stores/users/systemUsersShortData'
import systemsUsers from '@/stores/users/systemUsers'
import users from '@/stores/users/users'
import cardPools from '@/stores/users/cardPools'
import systemGroups from '@/stores/users/systemGroups'
import accountsGroups from '@/stores/users/accountsGroups'
import accounts from '@/stores/users/accounts'
import accessCards from '@/stores/users/accessCards'
import deletedUsers from '@/stores/users/deletedUsers'
import notifications from '@/stores/users/notifications'
import ipGroups from '@/stores/users/ipGroups'
import telephoneNumbr from '@/stores/users/telephoneNumbr'
import document from '@/stores/users/documents'
import servicesLinks from '@/stores/users/servicesLinks'
import tariffLinks from '@/stores/users/tariffLinks'
import techParams from '@/stores/users/techParams'
import contracts from '@/stores/users/contracts'
import contacts from '@/stores/users/contacts'
import servicesLinkOneTime from '@/stores/users/servicesLinkOneTime'
import servicesLinkPeriodic from '@/stores/users/servicesLinkPeriodic'
import servicesLinkIPTraffic from '@/stores/users/servicesLinkIPTraffic'
import servicesLinkHotspot from '@/stores/users/servicesLinkHotspot'
import servicesLinkDialup from '@/stores/users/servicesLinkDialup'
import servicesLinkTelephony from '@/stores/users/servicesLinkTelephony'
import servicesLinkVOD from '@/stores/users/servicesLinkVOD'
import servicesLinkIPTV from '@/stores/users/servicesLinkIPTV'
import servicesLinkFreezed from '@/stores/users/servicesLinkFreezed'
import bonuses from '@/stores/users/bonuses'
import dashboard from '@/stores/users/dashboard'
import support from '@/stores/users/support'
import paymentsUsers from '@/stores/users/payments'

import paymentMethods from '@/stores/referencebooks/paymentMethods'
import currencies from '@/stores/referencebooks/currencies'
import banks from '@/stores/referencebooks/banks'
import IPzones from '@/stores/referencebooks/IPzones'
import buildings from '@/stores/referencebooks/buildings'
import streets from '@/stores/referencebooks/streets'

import switchTypes from '@/stores/inventory/switchTypes'
import switches from '@/stores/inventory/switches'
import dhcpPools from '@/stores/inventory/dhcpPools'
import dhcpOptions from '@/stores/inventory/dhcpOptions'
import dhcpLeaseInventory from '@/stores/inventory/dhcpLease'

import blockings from '@/stores/reports/blockings'
import changeLog from '@/stores/reports/changeLog'
import sessions from '@/stores/reports/sessions'
import dhcpLease from '@/stores/reports/dhcpLease'
import payments from '@/stores/reports/payments'
import paymentOrders from '@/stores/reports/paymentOrders'
import internalTransfer from '@/stores/reports/internalTransfer'
import expiringPayments from '@/stores/reports/expiringPayments'
import otherCharges from '@/stores/reports/otherCharges'
import documents from '@/stores/reports/documents'
import general from '@/stores/reports/general'
import services from '@/stores/reports/services'
import customChargesReport from '@/stores/reports/customChargesReport'
import traffic from '@/stores/reports/traffic'
import telephony from '@/stores/reports/telephony'
import telephonyDirections from '@/stores/reports/telephonyDirections'
import detailedTraffic from '@/stores/reports/detailedTraffic'
import invoices from '@/stores/reports/invoices'

import login from '@/stores/login'
Vue.use(Vuex)

function moduleUnion (modules) {
  let result = {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {}
  }
  for (let el of modules) {
    result.state = {...el.state, ...result.state}
    result.getters = {...el.getters, ...result.getters}
    result.mutations = {...el.mutations, ...result.mutations}
    result.actions = {...el.actions, ...result.actions}
  }
  return result
}

export const store = new Vuex.Store({
  getters: {
  },
  mutations: null,
  actions: null,
  modules: {
    Settings: moduleUnion([switchTariff, promisedPayment, transferFunds, registrySettings, netFlowProviders, trafficCollectors,
      profilesOfDocuments, replacementsInDocument, archiveDB, documentTemplates, emergencyCalls, ipPools, paymentSystems,
      companies, ISGattributes, TunnelRadAttributes, voluntarySuspension, telephoneOperators, telSupplierServiceReports, firewalls, firewallRules,
      additional, NASlist, ISGprofile, userIndependentServicesConnect, radiusAccounts, dynamicShaping, userIndependentServicesConnect,
      rabbitMQ, httpServers, license, DHCPv6, collectors, captivePortal, rentsoft, chat, editProfile, availReports, availDocs, routes,
      permissions, activatingCard, tv24]),
    Tariffing: moduleUnion([tariff, service, telZones, telDirections, timeRange, radiusAttr, accountingPeriod, oneTimeService, periodicServices, ipTrafficServices,
      dialupServices, hotspotServices, telephonyServices, IPTVservices, vodServices, freezedServices, trafficClasses, contractType, coefficientScheme, chargePolicies,
      payment]),
    Users: moduleUnion([groups, irdeto, systemUsersShortData, systemsUsers, users, cardPools, systemGroups, accountsGroups, accounts, accessCards, deletedUsers, ipGroups, telephoneNumbr,
      document, servicesLinks, tariffLinks, techParams, contracts, contacts, servicesLinkOneTime, servicesLinkPeriodic, servicesLinkFreezed, servicesLinkHotspot, notifications,
      servicesLinkTelephony, servicesLinkDialup, servicesLinkIPTV, servicesLinkVOD, servicesLinkIPTraffic, bonuses, paymentsUsers]),
    ReferenceBooks: moduleUnion([paymentMethods, currencies, banks, IPzones, buildings, streets]),
    Inventory: moduleUnion([switchTypes, switches, dhcpPools, dhcpOptions, dhcpLeaseInventory]),
    Reports: moduleUnion([blockings, changeLog, sessions, dhcpLease, payments, paymentOrders, internalTransfer, expiringPayments, otherCharges,
      documents, general, services, customChargesReport, traffic, telephony, telephonyDirections, detailedTraffic, invoices]),
    Dashboard: dashboard,
    Support: support,
    Login: login
  }
})



// WEBPACK FOOTER //
// ./src/store.js